import SubNavigation from '@rio-cloud/rio-uikit/SubNavigation';
import { NavLink } from 'react-router-dom';

import { routes } from '../routes/routes';

const SubNavigationBar = () => (
    <SubNavigation
        navItems={[
            {
                key: '1',
                route: <NavLink to={routes.STREAMS}>Streams</NavLink>,
            },
            {
                key: '2',
                route: <NavLink to={routes.MONITORS}>Monitors</NavLink>,
            },
        ]}
    />
);

export default SubNavigationBar;
